import React from 'react';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { Balance } from '../../components/Balance/Balance';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { Donor } from '../../components/Donor/Donor';
import { Donations } from '../../components/Donations/Donations';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { AccountModalUsageContext } from '../../context/AccountFormProvider.meta';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <AccountOwnership label="Donor" />
      <AccountDescription />
      <AccountNickname />
      <Balance />
      <GrossEstateCheckbox isDefaultExcluded />
      <ManagementStyle />
      <AssetBucketing />
    </TabWrapper>
  );
};

const Details = () => {
  return (
    <TabWrapper>
      <Donations />
    </TabWrapper>
  );
};

export const DonorAdvisedFund = (props: FormComponentProps) => {
  const { usageContext } = useAccountFormContext();

  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        ...(usageContext !== AccountModalUsageContext.DafAccounts
          ? [{ name: 'Details', Component: Details }]
          : []),
      ]}
    />
  );
};
